<mat-card>
    <mat-card-content role="alertdialog">
        <p>
            Are you sure you want to {{ data.action | uppercase }} this user?
        </p>
    </mat-card-content>
    <mat-card-actions>
        <button mat-button type="button" aria-label="Cancel user action" id="cancel-btn" (click)="onCancel()">
            CANCEL
        </button>
        <button mat-raised-button type="button" color="primary" aria-label="Confirm user action" id="confirm-btn"
            (click)="onConfirm()">
            CONFIRM
        </button>
    </mat-card-actions>
</mat-card>